/**
 * The one place the API origin is read from.
 *
 * Until 2026-09-04 about thirty files re-read `NEXT_PUBLIC_API_BASE_URL`
 * themselves, with two different fallbacks: `http://localhost:4000` in client
 * code and `https://api.progsity.io` in the server-only readers (`middleware.ts`,
 * the platform-settings and locale reads, the engine read). A build missing the
 * variable would have pointed half the app at a developer's machine and half at
 * production (found by the 2026-09-02 QA re-audit).
 *
 * One fallback, and it is production on purpose: the variable is set on Vercel
 * and in `.env.example`, so a build without it is a misconfigured build, and a
 * misconfigured build should talk to the real API (where a `localhost` origin is
 * refused by CORS and the failure is visible) rather than to a port that only
 * exists on a developer's machine. Local development gets `localhost:4000` from
 * `.env.local`, never from here.
 *
 * Bracket access on `process.env` is what the rest of the app uses and what
 * Next.js inlines into client bundles; keep it.
 */
export const PRODUCTION_API_BASE_URL = "https://api.progsity.io";

export function resolveApiBaseUrl(raw: string | undefined): string {
  const value = raw?.trim() ?? "";
  return (value.length > 0 ? value : PRODUCTION_API_BASE_URL).replace(/\/+$/, "");
}

/** The API origin, without a trailing slash. */
export function getApiBaseUrl(): string {
  return resolveApiBaseUrl(process.env["NEXT_PUBLIC_API_BASE_URL"]);
}
